import { addClassNames, addProps, classNames } from "../../utils";
import Button, { buttonClassName } from "./Button";
import ButtonLink from "./ButtonLink";
import Dropdown from "./Dropdown";
import DropdownButton from "./DropdownButton";

type Props = {
  children: React.ReactNode;
  className?: string;
};

export default function ButtonGroup({ children, className }: Props): JSX.Element {
  children = addProps(children, [Button, ButtonLink], { variant: "action" });
  children = addClassNames(
    children,
    "span",
    buttonClassName({ className: "pointer-events-none", size: "md", variant: "action" }),
  );

  return (
    <div className={classNames("inline-flex items-stretch", className)}>
      {addClassNames(children, [Button, DropdownButton, ButtonLink, Dropdown, "span"], (index, count) => {
        return [
          "-ml-[1px] focus:z-10",
          index === 0 && count !== 1 && "rounded-r-none",
          index !== 0 && index !== count - 1 && "rounded-none",
          index === count - 1 && count !== 1 && "rounded-l-none",
        ]
          .filter(Boolean)
          .join(" ");
      })}
    </div>
  );
}
